import { Component, Output, EventEmitter, OnDestroy, OnInit, AfterViewInit, ChangeDetectorRef, Inject, Renderer2, ViewChild, ElementRef, ViewChildren, QueryList, HostListener, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../services/layout.service';
import { Subscription } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { DOCUMENT } from '@angular/common';
import { CustomizerService } from '../services/customizer.service';
import { FormControl } from '@angular/forms';
import { LISTITEMS } from '../data/template-search';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'app/pages/content-pages/login/login.service';
import { HttpCommonMethods } from 'app/httpCommonMethods/httpCommonMethods';
import UserDetails from 'app/UserDetails/UserDetails';

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, AfterViewInit, OnDestroy {
  currentLang = "en";
  selectedLanguageText = "English";
  selectedLanguageFlag = "./assets/img/flags/us.png";
  toggleClass = "ft-maximize";
  placement = "bottom-right";
  logoUrl = 'assets/img/logo.png';
  menuPosition = 'Side';
  isSmallScreen = false;
  protected innerWidth: any;
  searchOpenClass = "";
  transparentBGClass = "";
  hideSidebar: boolean = true;
  public isCollapsed = true;
  layoutSub: Subscription;
  configSub: Subscription;
  userDetail : UserDetails[];
  pk_tb_user_details : any;
  email : String;
  employee_name : String;
  fk_tb_project :  String;
  address : String;
  contact_number : String;
  role : String ;
  fk_tb_roles : string;
  username : string;
  password : string;
  fk_tb_company_details : string;
  company_name : string;

  @ViewChild('search') searchElement: ElementRef;
  @ViewChildren('searchResults') searchResults: QueryList<any>;

  @Output()
  toggleHideSidebar = new EventEmitter<Object>();

  @Output()
  seachTextEmpty = new EventEmitter<boolean>();

  @Input()  fullName: string;
  @Output() fullNameChange = new EventEmitter<string>();
 
  listItems = [];
  control = new FormControl();

  //fullName : string;

  public config: any = {};

  constructor(public translate: TranslateService,
    private layoutService: LayoutService,
    private router: Router,
    private configService: ConfigService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private httpCommonMethods : HttpCommonMethods) {
      console.log('Inside NavBar !')
    const browserLang: string = translate.getBrowserLang();
    //translate.use(browserLang.match(/nl|en/) ? browserLang : "nl");
    translate.use("nl");
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;

    this.layoutSub = layoutService.toggleSidebar$.subscribe(
      isShow => {
        this.hideSidebar = !isShow;
      });

    this.pk_tb_user_details = localStorage.getItem('pk_tb_user_details');
    this.fk_tb_roles = localStorage.getItem('fk_tb_roles');
    this.username = localStorage.getItem('username');
    this.password = localStorage.getItem('password');
    this.fk_tb_company_details = localStorage.getItem('fk_tb_company_details');
    this.company_name = localStorage.getItem('company_name');
    this.email = localStorage.getItem('email');
    this.employee_name = localStorage.getItem('employee_name');
    this.fk_tb_project = localStorage.getItem('fk_tb_project');
    this.address = localStorage.getItem('address');
    this.contact_number = localStorage.getItem('contact_number');
    //this.currentUser = localStorage.getItem('currentUser');
    this.role = localStorage.getItem('role');
    this.getFullName();
    
  }

  ngOnInit() {
    this.listItems = LISTITEMS;

    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    }
    else {
      this.isSmallScreen = false;
    }
    this.getFullName();
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    })
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = event.target.innerWidth;
    if (this.innerWidth < 1200) {
      this.isSmallScreen = true;
    }
    else {
      this.isSmallScreen = false;
    }
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != "") {
      this.menuPosition = this.config.layout.menuPosition;
    }

    if (this.config.layout.variant === "Light") {
      this.logoUrl = 'assets/img/logo-dark.png';
    }
    else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.variant === "Transparent") {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    }
    else {
      this.transparentBGClass = "";
    }

  }

  onSearchKey(event: any) {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.add('first-active-item');
    }

    if (event.target.value === "") {
      this.seachTextEmpty.emit(true);
    }
    else {
      this.seachTextEmpty.emit(false);
    }
  }

  removeActiveClass() {
    if (this.searchResults && this.searchResults.length > 0) {
      this.searchResults.first.host.nativeElement.classList.remove('first-active-item');
    }
  }

  onEscEvent() {
    this.control.setValue("");
    this.searchOpenClass = '';
    this.seachTextEmpty.emit(true);
  }

  onEnter() {
    if (this.searchResults && this.searchResults.length > 0) {
      let url = this.searchResults.first.url;
      if (url && url != '') {
        this.control.setValue("");
        this.searchOpenClass = '';
        this.router.navigate([url]);
        this.seachTextEmpty.emit(true);
      }
    }
  }

  redirectTo(value) {
    this.router.navigate([value]);
    this.seachTextEmpty.emit(true);
  }


  ChangeLanguage(language: string) {
    this.translate.use(language);

    if (language === 'en') {
      this.selectedLanguageText = "English";
      this.selectedLanguageFlag = "./assets/img/flags/us.png";
    }
    else if (language === 'nl') {
      this.selectedLanguageText = "Netherlands";
      this.selectedLanguageFlag = "./assets/img/flags/nl.png";
    }
    
    // if (language === 'en') {
    //   this.selectedLanguageText = "English";
    //   this.selectedLanguageFlag = "./assets/img/flags/us.png";
    // }
    // else if (language === 'es') {
    //   this.selectedLanguageText = "Spanish";
    //   this.selectedLanguageFlag = "./assets/img/flags/es.png";
    // }
    // else if (language === 'pt') {
    //   this.selectedLanguageText = "Portuguese";
    //   this.selectedLanguageFlag = "./assets/img/flags/pt.png";
    // }
    // else if (language === 'de') {
    //   this.selectedLanguageText = "German";
    //   this.selectedLanguageFlag = "./assets/img/flags/de.png";
    // }
  }

  ToggleClass() {
    if (this.toggleClass === "ft-maximize") {
      this.toggleClass = "ft-minimize";
    } else {
      this.toggleClass = "ft-maximize";
    }
  }

  toggleSearchOpenClass(display) {
    this.control.setValue("");
    if (display) {
      this.searchOpenClass = 'open';
      setTimeout(() => {
        this.searchElement.nativeElement.focus();
      }, 0);
    }
    else {
      this.searchOpenClass = '';
    }
    this.seachTextEmpty.emit(true);



  }


  logout(){
    localStorage.clear();
    console.log('logging out !');
  }

  toggleNotificationSidebar() {
    this.layoutService.toggleNotificationSidebar(true);
  }

  toggleSidebar() {
    this.layoutService.toggleSidebarSmallScreen(this.hideSidebar);
  }

  updateUser(){
   
      let myArray = [];
      myArray.push(this.pk_tb_user_details);
      myArray.push(this.employee_name);
    this.router.navigate(['/forms/updateMyUserLayout'], 
      { relativeTo: this.route.parent , 
        queryParams: {  myArray } });
  }

  public getFullName(){
    
    console.log('Getting Emp Name' + this.pk_tb_user_details)
    this.httpCommonMethods.getFullName(this.pk_tb_user_details)
          .subscribe(data => {
            if (data != null) {
              console.log( data[0]['employee_name'])
              this.fullName = data[0]['employee_name'];
              this.fullNameChange.emit(this.fullName);
              // location.reload();
              this.cdr.detectChanges();
            }
            else {
              alert('Invalid Project Selected');
            }
          });
  }
}
